module.exports = __webpack_public_path__ + "img/sign_230620702_1.8507d782.png";